/* VetCBD cart drawer v2 — behaviour for the additions in snippets/cart-drawer.liquid.
   Everything talks to Shopify's native Cart AJAX API and re-renders through Dawn's own
   CartDrawer.renderContents(), so the Liquid modules (shipping bar, plan select, cross-sell,
   discount chips, subtotal) always come back from the section render. No app involved. */
(function () {
  'use strict';
  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  function drawer() { return document.querySelector('cart-drawer'); }

  function status(msg, isError) {
    var el = document.getElementById('VcbdCartStatus');
    if (!el) return;
    el.textContent = msg || '';
    el.classList.toggle('vcbd-cd__status--err', !!isError);
  }

  function render(state) {
    var d = drawer();
    if (!d) return;
    cartTouchedAt = Date.now();
    setTimeout(function () { dismissKlaviyo(0); }, 300);
    d.classList.toggle('is-empty', state.item_count === 0);
    d.renderContents(state);
    if (window.publish && window.PUB_SUB_EVENTS) {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vcbd-cart-drawer', cartData: state });
    }
  }

  function post(url, body) {
    var payload = Object.assign({}, body, { sections: SECTIONS, sections_url: window.location.pathname });
    var cfg = typeof fetchConfig === 'function' ? fetchConfig() : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } };
    return fetch(url, Object.assign({}, cfg, { body: JSON.stringify(payload) })).then(function (r) { return r.json(); });
  }

  /* 0. Buy-box add to cart -> open the drawer. The native vcbd buy box posts a plain form to
        /cart/add (it is not wrapped in Dawn's <product-form>), which lands on the cart page. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if (action.indexOf('/cart/add') === -1) return;
    if (form.closest('product-form') || form.closest('cart-drawer')) return;
    var d = drawer();
    if (!d || typeof d.renderContents !== 'function') return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn && btn.getAttribute('aria-disabled') === 'true') return;
    if (btn) { btn.setAttribute('aria-disabled', 'true'); btn.classList.add('loading'); }
    var fd = new FormData(form);
    fd.append('sections', SECTIONS.join(','));
    fd.append('sections_url', window.location.pathname);
    var cfg = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/javascript' } };
    cfg.headers = Object.assign({}, cfg.headers, { 'X-Requested-With': 'XMLHttpRequest' });
    delete cfg.headers['Content-Type'];
    cfg.body = fd;
    if (typeof d.setActiveElement === 'function') d.setActiveElement(document.activeElement);
    fetch(window.routes.cart_add_url, cfg)
      .then(function (r) { return r.json(); })
      .then(function (st) {
        if (st.status) {
          /* Let Shopify show the real error on the cart page. */
          form.submit();
          return;
        }
        if (window.publish && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: fd.get('id'), cartData: st });
        }
        d.classList.remove('is-empty');
        cartTouchedAt = Date.now();
        d.renderContents(st);
        status('Added to your cart.');
        setTimeout(function () { dismissKlaviyo(0); }, 300);
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) { btn.removeAttribute('aria-disabled'); btn.classList.remove('loading'); } });
  });

  /* 0b. Klaviyo popup guard: the welcome quiz (form Ws34JS) fires on a 7 s timer and lands on top
        of the drawer right after add-to-cart. While the drawer is open (or within 15 s of a cart
        change), dismiss any Klaviyo popup by clicking its own close button; the form's 5-day
        cooldown does not apply to a programmatic close, so it returns on a later page. */
  var cartTouchedAt = 0;
  function guardArmed() {
    var d = drawer();
    return (d && d.classList.contains('active')) || (Date.now() - cartTouchedAt < 15000);
  }
  function dismissKlaviyo(attempt) {
    attempt = attempt || 0;
    if (!guardArmed() || attempt > 25) return;
    var btn = document.querySelector('.klaviyo-close-form, [class*="klaviyo-close"]');
    if (btn) { btn.click(); return; }
    setTimeout(function () { dismissKlaviyo(attempt + 1); }, 200);
  }
  window.addEventListener('klaviyoForms', function (e) {
    if (!e.detail || e.detail.type !== 'open') return;
    dismissKlaviyo(0);
  });

  /* 1. Delivery select on a line: one-time <-> subscription, or a different frequency.
        Capture phase + stopPropagation: these controls live inside <cart-drawer-items>, and Dawn's
        CartItems treats every bubbled 'change' as a quantity input (it would show
        "You can only add this item in increments of undefined" and reset the control). */
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-vcbd-sub]')) { e.stopPropagation(); return; }
    var sel = t.closest('[data-vcbd-plan]');
    if (!sel) return;
    e.stopPropagation();
    var line = parseInt(sel.dataset.index, 10);
    var qtyInput = document.getElementById('Drawer-quantity-' + line);
    var quantity = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
    var body = { line: line, quantity: quantity, selling_plan: sel.value ? parseInt(sel.value, 10) : null };
    sel.disabled = true;
    status('Updating…');
    post(window.routes.cart_change_url, body)
      .then(function (st) {
        if (st.errors || st.status) { status(st.errors || st.message || 'Could not update that item.', true); sel.disabled = false; return; }
        render(st);
        status(sel.value ? 'Switched to subscription.' : 'Switched to one-time purchase.');
      })
      .catch(function () { status('Could not update that item. Please try again.', true); sel.disabled = false; });
  }, true);

  /* 2. Cross-sell row "Add" (with or without the subscription checkbox). */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-vcbd-add]');
    if (!btn) return;
    var row = btn.closest('[data-vcbd-row]');
    var sub = row ? row.querySelector('[data-vcbd-sub]') : null;
    var item = { id: parseInt(btn.dataset.variantId, 10), quantity: 1 };
    if (sub && sub.checked && btn.dataset.sellingPlan) item.selling_plan = parseInt(btn.dataset.sellingPlan, 10);
    btn.disabled = true;
    status('Adding…');
    post(window.routes.cart_add_url, { items: [item] })
      .then(function (st) {
        if (st.status || st.errors) { status(st.description || st.message || 'Could not add that item.', true); btn.disabled = false; return; }
        /* add.js returns the added items, not the cart; sections are attached, so re-render from them. */
        render(Object.assign({ item_count: 1 }, st));
        status('Added to your cart.');
      })
      .catch(function () { status('Could not add that item. Please try again.', true); btn.disabled = false; });
  });

  /* 3. Discount code: native cart discount (applies at checkout). */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-vcbd-discount]');
    if (!form) return;
    e.preventDefault();
    var input = form.querySelector('input');
    var code = (input.value || '').trim();
    if (!code) return;
    var btn = form.querySelector('button');
    btn.disabled = true; input.disabled = true;
    status('Checking code…');
    post(window.routes.cart_update_url, { discount: code })
      .then(function (st) {
        var codes = st.discount_codes || [];
        var match = null;
        for (var i = 0; i < codes.length; i++) { if ((codes[i].code || '').toUpperCase() === code.toUpperCase()) match = codes[i]; }
        if (match && match.applicable === false) {
          status('That code does not apply to this cart.', true);
          btn.disabled = false; input.disabled = false;
          /* Drop the rejected code again so it does not linger on the cart. */
          post(window.routes.cart_update_url, { discount: '' }).catch(function () {});
          return;
        }
        render(st);
        status(match ? 'Code ' + match.code + ' applied. It shows at checkout.' : 'Code saved for checkout.');
      })
      .catch(function () {
        /* Fallback: the classic discount URL sets the code cookie for checkout. */
        fetch('/discount/' + encodeURIComponent(code), { credentials: 'same-origin' })
          .then(function () { status('Code ' + code.toUpperCase() + ' will apply at checkout.'); })
          .catch(function () { status('Could not apply that code.', true); })
          .finally(function () { btn.disabled = false; input.disabled = false; });
      });
  });
})();
